import _ from 'underscore';
import Backbone from 'backbone';

const dependencyResolverHash = {};

/**
 * Class DependencyResolver with the static instance of the hash
 * Through global hash, dependencies can be inserted or resolved.
 *
 * @class DependencyResolver
 * @extends {Backbone.Model}
 */
export class DependencyResolver extends Backbone.Model {
  /**
   * Get the component with the given key.
   *
   * @static
   * @param {string} key - key string for getting the component
   * @returns {Object} - object mapped to the key
   */
  static get(key) {
    return dependencyResolverHash[key];
  }

  /**
   * Setting the component with the key
   *
   * @static
   * @param {string} key - string used to get the component
   * @param {Object} value - component maps to the key
   * @memberof DependencyResolver
   * @returns {undefined}
   */
  static set(key, value) {
    if (_.isString(key)) {
      dependencyResolverHash[key] = value;
    }
  }

  /**
   * Return the copy of the all the dependency objects
   *
   * @static
   * @returns {Object} - object of the dependency map.
   */
  static getAll() {
    return _.clone(dependencyResolverHash);
  }
}

